import { render } from "./BuildingsShowView.vue?vue&type=template&id=012536c0&scoped=true"
import script from "./BuildingsShowView.vue?vue&type=script&lang=js"
export * from "./BuildingsShowView.vue?vue&type=script&lang=js"

import "./BuildingsShowView.vue?vue&type=style&index=0&id=012536c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012536c0"]])

export default __exports__